const env = process.env.REACT_APP_ENV;

let API_URL: string;
let HELPER_ID: string;
if (env === 'local') {
  //API_URL = 'http://localhost:8080';
  API_URL = 'http://192.168.219.105:8080';
  HELPER_ID = 'leon';
} else if (env === 'dev') {
  API_URL = 'http://localhost:8080';
  HELPER_ID = 'leon';
} else if (env === 'prod') {
  API_URL = 'https://api.noobook.co.kr';
  HELPER_ID = 'ekida';
} else {
  API_URL = 'https://api.example.com';
  HELPER_ID = 'leon';
}

export { API_URL, HELPER_ID };
